<template>
  <div class="PersonVacationList">
    <div v-if="list.length > 0">
      <person-vacation-list-web :list="list" class="hidden-sm-and-down" />
      <person-vacation-list-mob :list="list" class="hidden-md-and-up" />
    </div>
    <div v-else>
      <EmptyList />
    </div>
  </div>
</template>

<script>
import PersonVacationListWeb from "./PersonVacationListWeb.vue";
import PersonVacationListMob from "./PersonVacationListMob.vue";
export default {
  components: {
    PersonVacationListWeb,
    PersonVacationListMob,
  },
  props: {
    args: Object,
  },
  mounted() {
    this.GetPeriodBeginAndEndDate();
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    GetPeriodBeginAndEndDate() {
      const params = new URLSearchParams();
      params.append("periodNumber", this.args.period);
      params.append("year", this.args.year);
      if(this.args.perno){
        params.append('employeeId', this.args.perno);
      }

      this.$store
        .dispatch("GetPeriodBeginAndEndDate", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            if (result.data.length > 0) {
              let data = result.data[0];

              //console.log(data);
              this.PersonVacationList(data.BeginDate, data.EndDate);
            }
          }
        });
    },
    PersonVacationList(BeginDate, EndDate) {
      const params = new URLSearchParams();
      params.append("beginDate", BeginDate);
      params.append("endDate", EndDate);
      params.append("searchKind", "10");
      if(this.args.perno){
        params.append('perno', this.args.perno);
      }
      
      this.$store.dispatch("PersonVacationList", { params }).then((result) => {
        ////console.log(result);
        if (result.type === "success") {
          this.list = result.data;
        }
      });
    },
  },
};
</script>

<style>
</style>